module.exports = __webpack_public_path__ + "media/greenhouse-hd02.b4dfe6d7.mp4";